/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type BackofficeUserManagementDisableBackofficeUserMutationVariables =
  Types.Exact<{
    input: Types.BackofficeUserManagementDisableBackofficeUserInput
  }>

export type BackofficeUserManagementDisableBackofficeUserMutation = {
  __typename?: 'Mutation'
  backofficeUserManagementDisableBackofficeUser: string
}

export const BackofficeUserManagementDisableBackofficeUserDocument = gql`
    mutation BackofficeUserManagementDisableBackofficeUser($input: BackofficeUserManagementDisableBackofficeUserInput!) {
  backofficeUserManagementDisableBackofficeUser(input: $input)
}
    `
export type BackofficeUserManagementDisableBackofficeUserMutationFn =
  Apollo.MutationFunction<
    BackofficeUserManagementDisableBackofficeUserMutation,
    BackofficeUserManagementDisableBackofficeUserMutationVariables
  >

/**
 * __useBackofficeUserManagementDisableBackofficeUserMutation__
 *
 * To run a mutation, you first call `useBackofficeUserManagementDisableBackofficeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserManagementDisableBackofficeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backofficeUserManagementDisableBackofficeUserMutation, { data, loading, error }] = useBackofficeUserManagementDisableBackofficeUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackofficeUserManagementDisableBackofficeUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackofficeUserManagementDisableBackofficeUserMutation,
    BackofficeUserManagementDisableBackofficeUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackofficeUserManagementDisableBackofficeUserMutation,
    BackofficeUserManagementDisableBackofficeUserMutationVariables
  >(BackofficeUserManagementDisableBackofficeUserDocument, options)
}
export type BackofficeUserManagementDisableBackofficeUserMutationHookResult =
  ReturnType<typeof useBackofficeUserManagementDisableBackofficeUserMutation>
export type BackofficeUserManagementDisableBackofficeUserMutationResult =
  Apollo.MutationResult<BackofficeUserManagementDisableBackofficeUserMutation>
export type BackofficeUserManagementDisableBackofficeUserMutationOptions =
  Apollo.BaseMutationOptions<
    BackofficeUserManagementDisableBackofficeUserMutation,
    BackofficeUserManagementDisableBackofficeUserMutationVariables
  >
